import type { ComponentProps } from 'react';

import { CheckoutContent } from './CheckoutContent/CheckoutContent';
import { CheckoutProvider, type CheckoutProviderProps } from './checkout-provider/CheckoutProvider';

type CheckoutProps = ComponentProps<typeof CheckoutContent> & CheckoutProviderProps;

/**
 * Renders the checkout content for a given checkout id with the checkout provider context.
 * If the checkout returns no carts or errors the onCheckoutLoadingError function will be called.
 */
const Checkout = ({
  checkoutId,
  containerProps,
  onCheckoutLoadingError,
  onCheckoutSuccess,
  checkoutOrderSectionConfig,
  withCheckoutSuccessNotification,
  withEnrollmentSection,
}: CheckoutProps) => {
  return (
    <CheckoutProvider
      checkoutId={checkoutId}
      onCheckoutSuccess={onCheckoutSuccess}
      checkoutOrderSectionConfig={checkoutOrderSectionConfig}
      withCheckoutSuccessNotification={withCheckoutSuccessNotification}
    >
      <CheckoutContent
        containerProps={containerProps}
        withEnrollmentSection={withEnrollmentSection}
        onCheckoutLoadingError={onCheckoutLoadingError}
      />
    </CheckoutProvider>
  );
};

export { Checkout };
